import { useState } from "react";
import "./forms.css";
import { auth, database } from "./firebase";
import { useNavigate, Link } from "react-router-dom";
import {
	createUserWithEmailAndPassword,
	sendEmailVerification
} from "firebase/auth";
import { useAuthValue } from "./AuthContext";
import { ref, set } from "firebase/database";

function Register() {
	const [name, setName] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const { setTimeActive } = useAuthValue();

	const validatePassword = () => {
		let isValid = true;
		if (password !== "" && confirmPassword !== "") {
			if (password !== confirmPassword) {
				isValid = false;
				setError("Las contraseñas no coinciden");
			}
		}
		return isValid;
	};

	const validateTerms = () => {
		let isValid = true;
		if (!termsAccepted) {
			isValid = false;
			setError("Debe aceptar los terminos y condiciones");
		}
		return isValid;
	};

	const register = e => {
		e.preventDefault();
		setError("");
		if (validatePassword() && validateTerms()) {
			// Create a new user with email and password using firebase
			createUserWithEmailAndPassword(auth, email, password)
				.then(userCredential => {
					const uid = userCredential.user.uid;
					const userRef = ref(database, "users/" + uid);
					//const userRef = database.ref("users/" + uid);
					const userData = {
						id: uid,
						name,
						phone,
						email,
						activeMode: "user",
						expertMode: "no",
						userNew: "yes",
						userStatus: "none",
						userRequestId: "none"
					};
					set(userRef, userData)
						.then(() => {
							sendEmailVerification(auth.currentUser)
								.then(() => {
									setTimeActive(true);
									navigate("/verify-email");
								})
								.catch(err => alert(err.message));
						})
						.catch(err => setError(err.message));
				})
				.catch(err => setError(err.message));
		}
		setEmail("");
		setPassword("");
		setConfirmPassword("");
		setName("");
		setPhone("");
	};

	return (
		<div className="center">
			<div className="auth">
				<div>
					<img src="logo.png" alt="Logo" width={300} />
				</div>
				<div>
					<h1 style={{ fontSize: 26, color: "#03a99f", fontWeight: "bold" }}>
						Registro
					</h1>
				</div>
				{error &&
					<div className="auth__error">
						{error}
					</div>}
				<div>
					<form onSubmit={register} name="registration_form">
						<input
							type="text"
							value={name}
							placeholder="Nombre y Apellido"
							required
							onChange={e => setName(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>

						<input
							type="tel"
							value={phone}
							required
							placeholder="Numero de telefono"
							onChange={e => setPhone(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>
						<input
							type="email"
							value={email}
							placeholder="Direccion de correo"
							required
							onChange={e => setEmail(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>

						<input
							type="password"
							value={password}
							required
							placeholder="Introduzca su contraseña"
							onChange={e => setPassword(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>

						<input
							type="password"
							value={confirmPassword}
							required
							placeholder="Introduzca su contraseña nuevamente"
							onChange={e => setConfirmPassword(e.target.value)}
							style={{ color: "#03a99f", fontSize: 14, borderColor: "#001439" }}
						/>

						<label>
							<input
								type="checkbox"
								checked={termsAccepted}
								onChange={e => setTermsAccepted(e.target.checked)}
							/>
							<span style={{ color: "#03a99f", fontSize: 14 }}>
								He leído y acepto los{" "}
								<a
									href="https://tiluchi-service.web.app/PoliciesGeneral"
									target="_blank"
									rel="noopener noreferrer"
								>
									términos y condiciones
								</a>
							</span>
						</label>

						<button type="submit" style={{ backgroundColor: "#001439" }}>
							<span style={{ color: "white", fontSize: 16 }}>Crear</span>
						</button>
					</form>
				</div>
				<span>
					Ya tienes cuenta?
					<Link to="/login"> Inicia Sesion</Link>
				</span>
			</div>
		</div>
	);
}

export default Register;
